/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import svgMapper from './svgMapper';


class SvgCompose extends React.PureComponent {
  constructor(props) {
    super(props);
    const { className, iconUri, activeUri, active, width, height, color, alt, ...others } = props;
    this.others = others;

    const svgOrUrl = svgMapper(props.iconUri, color);
    if (typeof svgOrUrl !== 'string') {
      const { icon, fillInactive, fillActive, widthIcon, heightIcon } = svgOrUrl;
      const customWidth = width || widthIcon;
      const customHeight = height || heightIcon;
      this.activeChild = React.createElement(icon, { fill: fillActive, width: customWidth, height: customHeight });
      this.inactiveChild = React.createElement(icon, { fill: fillInactive, width: customWidth, height: customHeight });
    } else {
      this.activeChild = (<img width={width} height={height} alt={alt} src={activeUri} />);
      this.inactiveChild = (<img width={width} height={height} alt={alt} src={iconUri} />);
    }
    this.state = {
      active,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active !== this.state.active) {
      this.setState({ active: !!nextProps.active });
    }
  }

  render() {
    const child = this.state.active ? this.activeChild : this.inactiveChild;
    return (
      <span
        className={this.props.className}
        {...this.others}
      >
        {child}
      </span>
    );
  }
}
SvgCompose.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  iconUri: PropTypes.string,
  activeUri: PropTypes.string,
  active: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  color: PropTypes.object,
  alt: PropTypes.string,
};
SvgCompose.defaultProps = {
  className: '',
  iconUri: null,
  activeUri: null,
  active: false,
  width: undefined,
  height: undefined,
  color: {},
  alt: 'img',
};

export default SvgCompose;
